export const gridStyles = {
  default: {
    gridGap: 10,
    gridPadding: 20,
    slotSize: 64,
    slotPadding: 5,
    numberSize: 52,
  },
  small: {
    gridGap: 5,
    gridPadding: 10,
    slotSize: 56,
    slotPadding: 3,
    numberSize: 48,
  },
  extraSmall: {
    gridGap: 3,
    gridPadding: 5,
    slotSize: 50,
    slotPadding: 0,
    numberSize: 48,
  },
};
